// extracted by mini-css-extract-plugin
module.exports = {"heading":"InseratePage_heading__1jkL5","content":"InseratePage_content__3vBUK","linkActive":"InseratePage_linkActive__1N_Y_"};